import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import Core, { GameOrientation } from '../../Core/Core';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import SagaTracking from '../../Managers/Tracking/SagaTracking';
import { Platform } from '../../SDK/SDK';
import { lerp } from '../../Utils/Utils';
import RoundedIconButton from '../Shared/Buttons/RoundedIconButton';
import { UIButton } from '../Shared/Buttons/UIButton';

export class BottomMapUi extends PIXI.Sprite {
    private buttons: Map<Popup, RoundedIconButton> = new Map<Popup, RoundedIconButton>();
    private bg1: PIXI.Sprite;
    private bg2: PIXI.Sprite;

    constructor() {
        super();

        // this.texture = PIXI.utils.TextureCache['mapui/lowerhud-bg-round'];

        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
        if (isPortrait) {
            this.texture = PIXI.utils.TextureCache['mapui/lowerhud-bg-round'];
            this.alpha = 1;
        } else {
            this.bg1 = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/lowerhud-bg-1']);
            this.bg1.scale.set(1.5);
            this.bg1.alpha = 1;
            this.bg2 = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/lowerhud-bg-2']);
            this.bg2.scale.set(1.5);
            this.bg2.alpha = 1;
        }

        this.anchor.set(0.5);
        this.resize(getGameSize());
    }

    public addButton(iconId: string, popup: Popup, scale: number = 1) {
        const created = new RoundedIconButton(iconId, scale);
        created.on(UIButton.events.Trigger, () => {
            const gift = created.highlighted ? '_highlighted' : '';
            SagaTracking.trackMenuClick(`${Popup[popup]}${gift}`);
            HudEmitter.instance.emit(HudActions.ADD_POPUP, popup);
            created.hideNotification();
        });

        this.buttons.set(popup, created);
        this.positionButtons();
        this.addChild(created);
        return created;
    }

    public resize(sizeInfo: IGameSizeInfo) {
        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
        if (isPortrait) {
            this.x = this.width / 2.3;
            this.y = sizeInfo.gameHeight - this.height / 2 + 2;
        } else {
            this.addChild(this.bg1, this.bg2);

            this.bg1.x = 0;
            this.bg2.x = sizeInfo.gameWidth - this.bg2.width;
            this.bg1.y = sizeInfo.gameHeight * 0.22;
            this.bg2.y = sizeInfo.gameHeight - this.bg2.height;
        }
        this.positionButtons();
    }

    public cleanUp() {
        this.buttons.forEach(x => x.cleanUp());
    }

    public getButton(popup: Popup) {
        return this.buttons.get(popup);
    }

    public positionButtons() {
        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
        const buttons = this.buttons.values();
        const count = this.buttons.size;
        const width = this.width * (0.11 + (1 - 1 / count));

        if (isPortrait) {
            for (let i = 0; i < count; i++) {
                const button = buttons.next().value;
                const step = width / count;
                button.x = button.width / 2 + i * step - this.width / 2 + (this.width - width) / 2;
                const mid = (count - 1) / 2;
                const index = i < mid ? i : count - 1 - i;
                button.y = -button.height * lerp(0.1, 0.4, index / mid);
            }
        } else {
            const keys = this.buttons.keys();
            const leftButtons = [];
            const bottomButtons = [];

            for (let i = 0; i < count; i++) {
                const buttonKey = keys.next().value;
                if (buttonKey === Popup.MAPGATE || buttonKey === Popup.SHOP) {
                    bottomButtons.push(this.buttons.get(buttonKey));
                } else {
                    leftButtons.push(this.buttons.get(buttonKey));
                }
            }

            leftButtons.forEach((button, index, arr) => {
                const steps = arr.length;
                const ySpacing = (this.bg1.height * 0.9) / (steps + 1);
                button.x = arr.length === 1 ? this.bg1.width : this.bg1.width * 0.5;
                if (sgPlatform === Platform.Network) {
                    button.y =
                        this.bg1.y - this.bg1.height * 0.1 + this.bg1.height - ySpacing * 1.45;
                } else {
                    button.y =
                        this.bg1.y -
                        this.bg1.height * 0.1 +
                        this.bg1.height -
                        ySpacing * (index + 1);
                }
                this.addChild(button);
            });

            bottomButtons.forEach((button, index, arr) => {
                const steps = arr.length;
                const xSpacing = this.bg2.width / (steps + 1);
                const ySpacing = (this.bg2.height * 0.9) / (steps + 1);
                const newScale = button.originalScale.x > 1 ? button.originalScale.x : 1.1;
                button.scale.set(newScale);
                button.originalScale.set(newScale);
                button.x = this.bg2.x + this.bg2.width * 0.1 + xSpacing * (index + 1);
                button.y =
                    this.bg2.y - this.bg2.height * 0.1 + this.bg2.height - ySpacing * (index + 1);
                this.addChild(button);
            });
        }
    }
}
